export default {
    button: false
}